"use client";
import { useEffect, useRef } from "react";
import { bindMagazineMenus } from "@/lib/magazineMenus";

export default function MagazineHeaderFrame({ children }) {
  const ref = useRef(null);
  useEffect(() => bindMagazineMenus(ref.current, document), []);
  return <header className="mag-header" ref={ref}>{children}</header>;
}
